module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.imgArr), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.src
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-059886c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/swipe.vue
// module id = 324
// module chunks = 1